import images from './images';

export const skills = [
  {
    title: 'React Native',
    image: images.react_native,
  },
  {
    title: 'Javascript',
    image: images.javascript,
  },
  {
    title: 'React JS',
    image: images.react,
  },
  {
    title: 'HTML/CSS',
    image: images.html,
  },
  {
    title: 'Node JS',
    image: images.node,
  },
  {
    title: 'Git',
    image: images.git,
  },
  {
    title: 'Typescript',
    image: images.typescript,
  },
];
